import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPractitionerList } from "../../api/Individual";
import { failed } from "../../common/Toastify";
import {ResourceFormikObj, resourceTableTitle, resourceTableTitleSuperAdmin, noDataAvailText, truncateText} from "./constant";
import TextInput from "../../common/textfield/TextInput";
import moment from "moment";
import { useFormik } from 'formik'
import './ResourceHub.css';
import { Col, Row, Table } from "react-bootstrap";
import { Skeleton, TableCell, Tooltip } from "@mui/material";
import SearchSelect from "../../common/textfield/SearchSelect";
import { Button } from "../../common/Button";
import EditIcon from "../../../assets/images/editIcon.svg"
import CustomPagination from "../../common/components/Pagination/CustomPagination";
import { useNavigate, Link } from "react-router-dom";
import { deleteDocument, getDocumentReference, getAuthorizedResources } from "../../api/FillableDocument.js";
import { getOrganization } from "../../api/Organization/index.js";
import { EditResource } from "./editResource.js";
import { CreateResource } from "./createResource.js";
import { ViewDate } from "../../../utils/DateSupport.js";
import AddDocuments from "../../../assets/images/addDocuments.svg"
import { ViewLocation } from "./ViewLocation.js";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery.js";


const ResourcesHub = () => {
  const permissions = useSelector((state) => state?.auth?.user?.permissions); 
  const navigate = useNavigate();
  const [documentList, setDocumentList] = useState([]);
  const [filteredDocumentList, setFilteredDocumentList] = useState([]);
  const totalRows = filteredDocumentList?.length;
  const [page, setPage] = useState(0);
  const rowsPerPage = 6;
  const [modalShow, setModalShow] = useState(false);
  const [createModalShow, setCreateModalShow] = useState(false);
  const [viewlocationData, setViewlocationData] = useState(false);
  const handleCreateShow = () => {setCreateModalShow(!createModalShow)} 
  const handleShow = (data) => { setModalShow(modalShow ? false : data) };
  const [attachmentUrl, setAttachmentUrl] = useState('');
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [isViewDoc, setIsViewDoc] = useState(false);
  const [docData, setDocData] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const userRoles = useSelector((state) => state?.auth?.user?.["cognito:groups"]);
  const organization = useSelector((state) => state?.auth?.user?.organizations)
  const orgId = organization?.[0]?.id
  const isAdmin =userRoles?.includes("Super-Admin");
  const hasResourcesWritePermissions = isAdmin || permissions.some(permission => permission === 'Write Document Reference')

  const [orgList, setOrgList] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState("All"); 
  const [selectedStatus, setSelectedStatus] = useState("Active");
  const [organizations, setOrganizations] = useState([]);
  const [orgNameMap, setOrgNameMap] = useState({}); // Map of orgId -> orgName
  
  
  const onSuccessLocations = (data) => {
    setLocations(data);
  };

  useClinicLocationsQuery({ onSuccess: onSuccessLocations, orgIds: [orgId] });

  const userOrganizationId = useSelector(
      (state) => state?.auth?.user?.["organizations"][0].id
  );

  const isAncestorOrg = (resourceOrgId, userOrgId) => {
    if (!resourceOrgId || !userOrgId) return false;
    if (resourceOrgId === userOrgId) return false;
    return userOrgId.startsWith(resourceOrgId + ".");
  };

  let tableTitle = [...(isAdmin ? resourceTableTitleSuperAdmin : resourceTableTitle)];

  if (!hasResourcesWritePermissions) {
    tableTitle.pop();
  }

  const applyFilters = (orgFilter, statusFilter, searchTerm, baseList) => {
    let filtered = baseList ?? documentList;

    if (searchTerm) {
      filtered = filtered.filter((d) =>
        d.content?.[0]?.attachment?.title
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase())
      );
    }

    if (orgFilter && orgFilter !== "All") {
      filtered = filtered.filter((d) => {
        const orgId = (d?.custodian?.reference || "").split("/")[1] || "";
        const orgName = orgNameMap[orgId] || "";
        return orgName === orgFilter;
      });
    }

    if (statusFilter) {
      filtered = filtered.filter((d) =>
        statusFilter === "Active" ? d.status === "current" : d.status !== "current"
      );
    }

    setFilteredDocumentList(filtered);
    setPage(0);
  };

  

  const formik = useFormik({
      ...ResourceFormikObj,
      onSubmit: (values) => {
          // Other form submission logic
      }
  });

  const sortByNameAscending = (data) => {
      return data?.sort((a, b) => {
          let titleA = a?.content?.[0]?.attachment?.title;
          let titleB = b?.content?.[0]?.attachment?.title

          if (titleA < titleB) return -1;
          if (titleA > titleB) return 1;
          return 0;
      });
  };

  const fetchOrganizations = async () => {
    try {
      const res = await getOrganization(); // Fetch all organizations without ID
      const orgs = Array.isArray(res?.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
      setOrganizations(orgs);
      
      // Create a map of orgId -> orgName for quick lookups
      const nameMap = {};
      const normalize = s => (s || "").normalize("NFKD").trim().toLowerCase();
      
      orgs.forEach((org) => {
        if (org?.id && org?.name) {
          nameMap[org.id] = org.name;
        }
      });
      setOrgNameMap(nameMap);
      
      // Populate dropdown with all organization names
      const orgNames = orgs
        .map((org) => org?.name)
        .filter(Boolean);
      
      const sortedOrgNames = Array.from(new Set(orgNames)).sort((a, b) =>
        normalize(a).localeCompare(normalize(b), undefined, { numeric: true })
      );
      setOrgList(sortedOrgNames);
    } catch (err) {
      console.error("Error fetching organizations:", err);
    }
  };

  const getListOfDocument = async () => {
    setIsLoading(true);
    try {
      const res = await getAuthorizedResources();
      const sorted = sortByNameAscending(res.result || []);
      setDocumentList(sorted);
      
      // Apply filters - orgList is already populated from fetchOrganizations
      applyFilters(selectedOrg, selectedStatus, formik.values.name, sorted);
    } catch (err) {
      failed("Error fetching resources");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    const term = e.target.value;
    formik.setFieldValue("name", term);
    applyFilters(selectedOrg, selectedStatus, term);
  };

  const handleOrgChange = (selected) => {
    const org = selected?.value || "All";
    setSelectedOrg(org);
    applyFilters(org, selectedStatus, formik.values.name);
  };

  const handleStatusChange = (selected) => {
    const status = selected?.value || "Active";
    setSelectedStatus(status);
    applyFilters(selectedOrg, status, formik.values.name);
  };

  const handleLinkOpen = async(url) => {
    const fullUrl = url.startsWith("http") ? url : `https://${url}`;
    window.open(fullUrl, "_blank", "noopener,noreferrer");
  }

  const handleViewLocation = async (id) => {
    if(viewlocationData){
        setViewlocationData(false)
    }else{
        const clickedLocation = locations.filter(loc => loc.id === id)[0]
        setViewlocationData(clickedLocation)
    }
  }

  useEffect(() => {
      fetchOrganizations();
  }, []);

  useEffect(() => {
      // Only fetch documents after organizations are loaded
      if (Object.keys(orgNameMap).length > 0) {
          getListOfDocument();
      }
  }, [orgNameMap]);

  return (
      <div >
        <ViewLocation modalShow={viewlocationData} handleShow={handleViewLocation}/>    
        <EditResource modalShow={modalShow} refreshTable={getListOfDocument} handleShow={handleShow} />
        <CreateResource modalShow={createModalShow} refreshTable={getListOfDocument} handleShow={handleCreateShow} />
          <form 
              className="common-form border-fields"
              onSubmit={(e) => {
                  e.preventDefault();
                  formik.handleSubmit();
              }}
              style={{ margin: "20px" }}
          >
              <Row>
                  <Col md={4}>
                      <TextInput
                          keyField={"name"}
                          label={"Search Resources"} 
                          formik={formik}
                          placeholder={"Search Resources"}
                          hideRequired={true}
                          onChange={handleSearchChange} 
                          value={formik.values.name} 
                      />
                  </Col>
                  {/* org dropdown */}
                    <Col md={2}>
                        <SearchSelect
                          label="Organization"
                          options={orgList.map(org => ({ label: org, value: org }))}
                          value={selectedOrg === "All"
                            ? null
                            : { label: selectedOrg, value: selectedOrg }
                          }
                          onChange={handleOrgChange}
                          placeholder="All"
                          isClearable={true}
                          hideRequired={true}
                        />
                    </Col>

                    {/* status dropdown */}
                    <Col md={2}>
                        <SearchSelect
                          label="Status"
                          options={[
                            { label: "Active", value: "Active" },
                            { label: "Inactive", value: "Inactive" },
                          ]}
                          value={{ label: selectedStatus, value: selectedStatus }}
                          onChange={handleStatusChange}
                          placeholder="Select Status"
                          isClearable={false}
                          hideRequired={true}
                        />
                    </Col>
                  {hasResourcesWritePermissions && <Col md={4}>
                    <div className="right-wrap" style={{justifyContent:"end"}}>
                      <Button
                        onClick={() => handleCreateShow()}
                        className="custom-btn"
                        title="Create"
                        >
                        <img src={AddDocuments} alt="Add Docs" style={{width : "28px"}}/>
                        Create
                      </Button>
                    </div>
                  </Col>}
              </Row>
          </form>

          <div className="table-wrap" style={{ margin: "20px" }}>
              <Table responsive>
                  <thead>
                      <tr>
                          {tableTitle?.map((title) => (
                            (title !== "Organization" || (title === "Organization" && selectedOrg === "All")) ?
                              <th
                                  key={title}
                                  style={title === "Action" ? { textAlign: "center" } : undefined}
                              >
                                  {title}
                              </th> : null
                          ))}
                      </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                        [1, 2, 3, 4, 5, 6].map((val) => (
                            <tr key={val}>
                                {tableTitle?.map((index) =>
                                (<td key={index}>
                                    <Skeleton animation="wave" />
                                </td>)
                                )}
                            </tr>
                            ))
                    )
                    :filteredDocumentList?.length > 0 ? (
                          filteredDocumentList
                              ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                              ?.map((data) => {
                                  const { id, documentName, location, description, status, date, content } = data;
                                  let url = content?.[0]?.attachment?.url
                                  let title = content?.[0]?.attachment?.title
                                  const resourceOrgId = (data?.custodian?.reference || "").split("/")[1] || "";
                                  const rowIsAncestor = isAncestorOrg(resourceOrgId, userOrganizationId);
                                  const canEditRow = hasResourcesWritePermissions && !rowIsAncestor;
                                  return (
                                      <tr key={id}>
                                          <td>
                                              <div
                                                  className="click-url"
                                                  title={url}
                                                  onClick={() =>  handleLinkOpen(url)}
                                              >
                                                  {title || documentName}
                                              </div>
                                          </td>

                                          <td
                                              style={{
                                                wordBreak: "break-word",
                                                maxWidth: "200px",
                                                whiteSpace: "pre-wrap"
                                            }}
                                          >
                                              <Tooltip title={description?.length > 100 ? description : ""} placement="top">
                                                    <span>{truncateText(description, 100)}</span>
                                                </Tooltip>
                                          </td>
                                          {userRoles?.includes("Super-Admin") && (
                                              <td>{orgNameMap[resourceOrgId] || " - "}</td>
                                          )}
                                          <td style={{ wordBreak: "break-word", maxWidth: "200px", whiteSpace: "pre-wrap" }}>
                                            {location?.length > 0 ? (
                                                <div style={{ paddingLeft: "5px", margin: 0 }}>
                                                    {location.map((item, index) => (
                                                        <>
                                                            <span
                                                                key={index}
                                                                onClick={() => handleViewLocation(item.reference.split("/")[1])}
                                                                title={"View Location"}
                                                                className="click-url"
                                                            >
                                                                {item.display}
                                                            </span>
                                                            {index < location.length - 1 && ", "}  {/* Add a comma separator */}
                                                        </>
                                                    ))}
                                                </div>
                                            ) : (
                                                "-"
                                            )}
                                          </td>
                                          {
                                            (selectedOrg === "All") ? 
                                            <td>
                                              {orgNameMap[resourceOrgId] || " - "}
                                            </td>: null
                                          }
                                          <td>{ViewDate(date)}</td>
                                          <td>
                                              {status === "current" ? "Active" : "Inactive"}
                                          </td>
                                          {hasResourcesWritePermissions && <td>
                                              {canEditRow ? (
                                                    <Tooltip title={"Update Details"}>
                                                      <Link to="" onClick={() => {handleShow(data)}}>
                                                        <img src={EditIcon} alt="Update" />
                                                      </Link>
                                                    </Tooltip>
                                                  ) : (
                                                    <Tooltip title={"View only (ancestor resource)"}>
                                                      <span style={{ opacity: 0.4, cursor: "not-allowed" }}>
                                                        <img src={EditIcon} alt="Update disabled" />
                                                      </span>
                                                    </Tooltip>
                                                )}
                                          </td>}
                                      </tr>
                                  );
                              })
                      ) : (
                          <tr>
                              <TableCell
                                  colSpan={tableTitle.length}
                                  style={{ textAlign: "center" }}
                              >
                                  {noDataAvailText}
                              </TableCell>
                          </tr>
                      )}
                  </tbody>
              </Table>
              {filteredDocumentList?.length > 0 && (
                  <div>
                      <CustomPagination
                          tableData={filteredDocumentList}
                          totalRows={totalRows}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          handlePage={(pageNo) => setPage(pageNo)}
                      />
                  </div>
              )}
          </div>
      </div>
  );
};

export default ResourcesHub;
